const LEFT_SESSION_STORAGE_PREFIX = "qit:left-session:";
const LEFT_SESSION_TTL_MS = 120000;

const getLeftSessionKey = (sessionId: string): string =>
    `${LEFT_SESSION_STORAGE_PREFIX}${sessionId}`;

export const markSessionRecentlyLeft = (sessionId: string): void => {
    const normalizedSessionId = String(sessionId || "").trim();
    if (!normalizedSessionId || typeof window === "undefined") return;

    try {
        window.sessionStorage.setItem(getLeftSessionKey(normalizedSessionId), String(Date.now()));
    } catch {
        // Session cleanup should continue even if storage is unavailable.
    }
};

export const clearSessionRecentlyLeft = (sessionId: string): void => {
    const normalizedSessionId = String(sessionId || "").trim();
    if (!normalizedSessionId || typeof window === "undefined") return;

    try {
        window.sessionStorage.removeItem(getLeftSessionKey(normalizedSessionId));
    } catch {
        // Ignore unavailable storage.
    }
};

export const wasSessionRecentlyLeft = (sessionId: string): boolean => {
    const normalizedSessionId = String(sessionId || "").trim();
    if (!normalizedSessionId || typeof window === "undefined") return false;

    try {
        const rawTimestamp = window.sessionStorage.getItem(getLeftSessionKey(normalizedSessionId));
        const leftAt = Number(rawTimestamp);
        if (!Number.isFinite(leftAt)) return false;

        const isRecent = Date.now() - leftAt < LEFT_SESSION_TTL_MS;
        if (!isRecent) {
            window.sessionStorage.removeItem(getLeftSessionKey(normalizedSessionId));
        }
        return isRecent;
    } catch {
        return false;
    }
};
